module.exports = __webpack_public_path__ + "img/checkmark-green-plain.57128510.svg";